export default __webpack_public_path__ + "static/media/SWT0750.34I-19567_-14925_0.0ebb3b8d.jpg";